module.exports = __webpack_public_path__ + "img/saving script.55b199c5.jpg";